export const SET_UNREAD_TOPICS_COUNT = 'SET_UNREAD_TOPICS_COUNT';

const setUnreadTopicsCount = ({ commit }, payload) => {
    commit(SET_UNREAD_TOPICS_COUNT, payload);
};

export default {
    setUnreadTopicsCount,
};
